// import { createFromIconfontCN } from '@ant-design/icons';
const MyIcon = (props) => {
    // const { url = '//at.alicdn.com/t/c/font_4070446_kb2navob1w.js', type } = props,
    //     Icon = createFromIconfontCN({
    //         scriptUrl: url // 在 iconfont.cn 上生成
    //     });
    // return <Icon style={props.style} type={type}></Icon>;
    return <span className={`iconfont ${props.type} ${props.className}`} style={props.style}></span>;
};
export default MyIcon;
